import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { SessionProvider } from "@/auth/SessionContext";
import { RequireAuth, RequireOperator, RequireAdmin } from "@/auth/RequireAuth";
import { AppShell, OperatorShell, AdminShell } from "@/components/AppShell";
import { DocumentTitle } from "@/components/DocumentTitle";
import { LandingPage } from "@/pages/Landing";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import { PrivacyPage, TermsPage } from "@/pages/Legal";
import { NotFoundPage } from "@/pages/NotFound";
import { DashboardPage } from "@/pages/app/Dashboard";
import { EnvironmentPage } from "@/pages/app/Environment";
import { EnvironmentSaveVariantsPage } from "@/pages/app/EnvironmentSaveVariants";
import { MachinesPage } from "@/pages/app/Machines";
import { ProjectDetailPage, ProjectsPage } from "@/pages/app/Projects";
import { WorkspaceRequestsPage } from "@/pages/app/WorkspaceRequests";
import { TaskDetailPage, TasksPage } from "@/pages/app/Tasks";
import { AccountPage } from "@/pages/app/Account";
import { IntegrationsPage } from "@/pages/app/Integrations";
import { OperationPage } from "@/pages/app/Operation";
import { LeaseDetailPage } from "@/pages/app/LeaseDetail";
import { OperatorOverviewPage } from "@/pages/operator/Overview";
import { OperatorWorkspaceRequestsPage } from "@/pages/operator/WorkspaceRequests";
import { AdminCabinetPage } from "@/pages/admin/Admin";

const adminHost = window.location.hostname === "agent-admin.cloud.tenqora.net";

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <DocumentTitle />
        <Routes>
          <Route path="/" element={adminHost ? <Navigate to="/admin" replace /> : <LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={adminHost ? <Navigate to="/login" replace /> : <RegisterPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/design/environment-save" element={<EnvironmentSaveVariantsPage />} />

          <Route
            path="/app"
            element={
              <RequireAuth>
                {adminHost ? <Navigate to="/admin" replace /> : <AppShell />}
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="environment" element={<EnvironmentPage />} />
            <Route path="machines" element={<MachinesPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/:projectId" element={<ProjectDetailPage />} />
            <Route
              path="projects/:projectId/workspace-requests"
              element={<WorkspaceRequestsPage />}
            />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="tasks/:taskId" element={<TaskDetailPage />} />
            <Route path="leases/:leaseId" element={<LeaseDetailPage />} />
            <Route path="operations/:operationId" element={<OperationPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="account" element={<AccountPage />} />
          </Route>

          <Route
            path="/operator"
            element={
              <RequireAuth>
                <RequireOperator>
                  <OperatorShell />
                </RequireOperator>
              </RequireAuth>
            }
          >
            <Route index element={<OperatorOverviewPage />} />
            <Route path="workspace-requests" element={<OperatorWorkspaceRequestsPage />} />
          </Route>

          <Route
            path="/admin"
            element={
              <RequireAuth>
                <RequireAdmin>
                  <AdminShell />
                </RequireAdmin>
              </RequireAuth>
            }
          >
            <Route index element={<AdminCabinetPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
}
